module.exports = __webpack_public_path__ + "img/selected4-min.27c400e0.png";